<template>
  <div
    :key="item.id"
    class="request-item"
    :style="
      color
        ? {
            borderLeft: `0.256rem solid ${color}`,
          }
        : {}
    "
  >
    <div class="flex flex-col min-w-0">
      <div class="item-title text-ellipsis">
        <a :href="hrefLink" target="_blank">{{
          `${item.name} ${item.subject}`
        }}</a>
      </div>
      <div class="item-sub-title">
        {{ item.createdAt | datetime }}
      </div>
    </div>
    <div class="flex items-center justify-end pl-4">
      <FlotoStatusPicker
        :module-name="moduleName"
        :value="item.statusId"
        disabled
      />
    </div>
  </div>
</template>

<script>
import { StatusComputed } from '@state/modules/status'
export default {
  name: 'RequestItem',
  props: {
    item: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  computed: {
    ...StatusComputed,
    color() {
      if (this[`${this.moduleName}Status`]) {
        return (
          this[`${this.moduleName}Status`].find(
            (s) => s.key === this.item.statusId
          ) || {}
        ).color
      }
      return undefined
    },
    hrefLink() {
      const link = this.$currentModule.getRoute('view-request', {
        params: { id: this.item.id },
      })
      return this.$router.resolve(link).href
    },
  },
}
</script>

<style lang="less" scoped>
.request-item {
  @apply rounded py-2 px-4 flex mb-2 justify-between;

  background: var(--neutral-lightest);

  .item-title {
    font-size: 0.813rem;
    font-weight: 400;

    & a {
      color: var(--page-text-color);
    }
  }

  .item-sub-title {
    @apply text-neutral;

    font-size: 0.688rem;
    font-weight: 300;
  }
}
</style>
